import { render } from "./NoteRich.vue?vue&type=template&id=a5b9d57e&scoped=true"
import script from "./NoteRich.vue?vue&type=script&lang=js"
export * from "./NoteRich.vue?vue&type=script&lang=js"

import "./NoteRich.vue?vue&type=style&index=0&id=a5b9d57e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b9d57e"]])

export default __exports__